import { action$, ofType } from '@ardoq/rxbeach';
import { filterInterface } from '@ardoq/filter-interface';
import { map, type Observable, shareReplay, startWith } from 'rxjs';
import { notifyFiltersChanged } from './FilterActions';

export const quickPerspectiveReferenceTypeFilters$: Observable<Set<string> | null> =
  action$.pipe(
    ofType(notifyFiltersChanged),
    startWith(null),
    map(() => filterInterface.getActiveQuickReferenceTypeFilters()),
    shareReplay({ bufferSize: 1, refCount: true })
  );
